// replace spaces and special characters in data-testids for cypress.get()
export const replaceCharsForCY = (input: string): string => {
  return input.replace(/[^-a-zA-Z0-9]+/g, `-`)
}
